export default __webpack_public_path__ + "static/media/amitronics.b5ee5c8f.webp";